import {inject, Injectable} from '@angular/core';
import {Auth, idToken} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  private readonly auth = inject(Auth)
  readonly authToken = idToken(this.auth)
  private _token: string | null = null

  constructor() {
    this.authToken.subscribe(it => this._token = it)
  }

  get token() {
    return this._token
  }
}
